module.exports = __webpack_public_path__ + "static/media/SalaryUpload.ec625df1.svg";